import { StyleSheet } from 'react-native';

import Shield from '@/assets/icons/shield';
import { Box, Image } from '@/components/lib/components';

const LOGO_SIZE = 24;

const styles = StyleSheet.create({
    logo: {
        width: LOGO_SIZE,
        height: LOGO_SIZE,
    },
});

type TeamLogoProps = {
    logoUrl: string;
    primaryColor: string;
    secondaryColor: string;
    shouldShowFallbackLogo: boolean;
};

export const TeamLogo = ({ logoUrl, primaryColor, secondaryColor, shouldShowFallbackLogo }: TeamLogoProps) =>
    shouldShowFallbackLogo ? (
        <Shield primary={primaryColor} secondary={secondaryColor} width={LOGO_SIZE} height={LOGO_SIZE} />
    ) : (
        <Box height={LOGO_SIZE} width={LOGO_SIZE} alignItems="center" justifyContent="center">
            <Image source={{ uri: logoUrl }} resizeMode="contain" style={styles.logo} />
        </Box>
    );
